import activityReducer from './activityReducer';
import errorsReducer from './errorsReducer';

const rootReducer = {
  activityBuilder: activityReducer,
  activityBuilderErrors: errorsReducer
};

export default rootReducer;
